import {Box, Checkbox, Container, Stack, Typography} from '@mui/material'
import React, {useState} from 'react'
import UploadImg from '../customTable/UploadImg'
import ErrorMsg from '../customTable/ErrorMsg'
import RedStart from '../customTable/RedStart'
import InputType from '../customTable/InputType'
import MySelect from '../customTable/CustomSelectTest'
import SaveButton from '../customTable/SaveButton'
import Banner from '../../Api/banner'
import IBanner from '../../interface/IBanner'
import {bannerSchema} from '../../yup/BannerShcema'
import * as Yup from 'yup'
import Loading from '../customTable/LoadingForm'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import {RootState} from '../../store'
import ValidationFun from '../../yup/ValidationFun'
import Label from '../customTable/Label'

export default function EditForm({
  setOpen,
  open,
  item,
  setItem,
  setRows,
  rows,
  isLoading,
  setUsLoading,
}: any) {
  const [base64Image, setBase64Image] = React.useState(item.image)
  const [banner, setBanner] = useState({
    ...item,
    type: item.type === 'banner' ? 1 : 2,
    isLink: item.video_url ? 'link' : 'update',
  })
  const {t} = useTranslation()

  const [msgErr, setMsgErr] = React.useState<string>('')
  const [errors, setErrors] = useState({})
  const saveChange = async () => {
    let newData = {
      ...banner,
      type: banner.type === 2 ? 'sub_banner' : 'banner',
      image: isLink === 'link' ? null : base64Image,
      video_url: isLink === 'link' ? banner.video_url : null,
      sort: banner.sort ? banner.sort : 0,
      media_type: isLink === 'link' ? 'video' : 'image',
      section: 'home',
    }
    if (isLink === 'link') {
      delete newData.image
    } else {
      if (newData.image && !newData.image.includes('base64')) {
        delete newData.image
      }
      delete newData.video_url
    }

    ValidationFun(
      {
        ...banner,
        type: !banner.type ? 'slider' : banner.type === 1 ? 'banner' : 'new_arrival',
        image: base64Image,
        sort: banner.sort ? banner.sort : 0,
        isLink: isLink === 'link',
      },
      bannerSchema,
      setErrors,
      (value: any) => {
        Banner.put(
          item.id,
          newData,
          (res: any) => {
            setItem(res)

            // setBase64Image('')
            setMsgErr('')
            setOpen(false)
            setBase64Image(res.image)
            setBanner({
              ...res,
            })
            setRows(
              [
                ...rows.filter((e: any) => e.id != item.id),
                {
                  ...res,
                },
              ].sort((a, b) => b.id - a.id)
            )
          },
          setUsLoading
        )
      }
    )
  }
  const store = useSelector((state: RootState) => state.vender)
  const toggle = ['link', 'update']
  const [isLink, setIsLink] = useState(item.video_url ? 'link' : 'update')
  return (
    <Container
      lang={store.lang}
      dir={store.isRtl === 0 ? 'ltr' : 'rtl'}
      sx={{padding: '7px 24px 28px 24px'}}
      maxWidth='md'
    >
      <p style={{width: '500px'}}></p>
      <Typography sx={{fontSize: '20px', fontWeight: '600', color: 'var(--bs-body-color)'}}>
        {t('editBanner')}
      </Typography>
      <Stack mt='24px' gap='16px' direction={'row'}>
        {toggle.map((e: any) => (
          <Stack
            sx={{cursor: 'pointer'}}
            onClick={() => {
              setIsLink(e)
            }}
            gap='8px'
            alignItems={'center'}
            direction={'row'}
          >
            <Checkbox
              checked={e === isLink}
              sx={{
                color: '#405189',
                padding: '0 !important',
                '&.Mui-checked': {
                  color: '#405189',
                },
              }}
            />
            <Label text={e} />
          </Stack>
        ))}
      </Stack>
      {isLink === 'update' && open && (
        <Stack mt='25px'>
          <UploadImg
            errors={errors}
            open={open}
            base64Image={item.image}
            setBase64Image={setBase64Image}
          />
          <ErrorMsg msgErr={msgErr} name='Image' />
        </Stack>
      )}

      <Stack mt='24px' width={'100%'} position={'relative'} gap={'12px'}>
        <Stack direction={'row'} gap='5px'>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: '16px',
              color: 'var(--bs-body-color)',
              lineHeight: '16px',
            }}
          >
            {t('title')}
          </Typography>
          <RedStart />
        </Stack>
        <Box width='100%'>
          <InputType errors={errors} name={'title'} change={setBanner} value={banner} type='text' />
        </Box>
        <ErrorMsg msgErr={msgErr} name='title' />
      </Stack>
      <Stack mt='24px' width={'100%'} position={'relative'} gap={'12px'}>
        <Stack direction={'row'} gap='5px'>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: '16px',
              color: 'var(--bs-body-color)',
              lineHeight: '16px',
            }}
          >
            {t('type')}
          </Typography>
          {/* <RedStart /> */}
        </Stack>

        <Box width='100%'>
          <MySelect
            option={[
              {name: t('banner'), id: 1},
              {name: t('subBanner'), id: 2},
            ]}
            values={banner}
            setValues={setBanner}
            name='type'
            value={{id: item.type === 'banner' ? 1 : 2}}
          />{' '}
        </Box>
        <ErrorMsg msgErr={msgErr} name='Type' />
      </Stack>
      <Stack mt='24px' width={'100%'} position={'relative'} gap={'12px'}>
        <Stack direction={'row'} gap='5px'>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: '16px',
              color: 'var(--bs-body-color)',
              lineHeight: '16px',
            }}
          >
            {t('section')}
          </Typography>
          {/* <RedStart /> */}
        </Stack>
        <Box width='100%'>
          <MySelect
            stringValue
            option={[
              // {name: t('all '), id: 'all'},
              {name: t('home'), id: 'home'},
              // {name: t('brands'), id: 'brands'},
              // {name: t('filter'), id: 'filter'},
              // {name: t('products'), id: 'products'},
              // {name: t('inside_product'), id: 'inside_product'},
              // {name: t('orders'), id: 'orders'},
              // {name: t('cart'), id: 'cart'},
            ]}
            values={banner}
            setValues={setBanner}
            name='section'
            value={{id: banner.section}}
            errors={errors}
          />{' '}
        </Box>
        <ErrorMsg msgErr={msgErr} name='Type' />
      </Stack>
      {isLink === 'link' && (
        <Stack gap='12px' mt='24px' width='100%'>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: '16px',
              color: 'var(--bs-body-color)',
              lineHeight: '16px',
            }}
          >
            {t('youtubeLink')}
          </Typography>
          <InputType
            errors={errors}
            name={'video_url'}
            change={setBanner}
            value={banner}
            type='text'
          />
        </Stack>
      )}
      <Stack mt='24px' width={'100%'} position={'relative'} gap={'12px'}>
        <Stack direction={'row'} gap='5px'>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: '16px',
              color: 'var(--bs-body-color)',
              lineHeight: '16px',
            }}
          >
            {t('sort')}
          </Typography>
          {/* <RedStart /> */}
        </Stack>
        <Box width='100%'>
          <InputType
            errors={errors}
            name={'sort'}
            change={setBanner}
            value={banner}
            type='number'
          />
        </Box>
        <ErrorMsg msgErr={msgErr} name='sort' />
      </Stack>
      <SaveButton text={t('saveChanges')} submit={saveChange} isLoading={false} setOpen={setOpen} />
      {isLoading && <Loading />}
    </Container>
  )
}
